import { render, staticRenderFns } from "./Dgii.vue?vue&type=template&id=b4862690&scoped=true"
import script from "./Dgii.vue?vue&type=script&lang=js"
export * from "./Dgii.vue?vue&type=script&lang=js"
import style0 from "./Dgii.vue?vue&type=style&index=0&id=b4862690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4862690",
  null
  
)

export default component.exports